import { useState, useEffect  } from "react";
import { Link } from "react-router-dom";
import logo from "../assets/logo-edbot.png";

const Navbar = () => {
  const [open, setOpen] = useState(false);

  // ▸ nuevo: ¿hay token válido en localStorage?
  const [isAuth, setIsAuth] = useState(false);

  useEffect(() => {
    const tok = localStorage.getItem("token");
    setIsAuth(!!tok);                       // true si existe
  }, []);                                   // solo al montar

  return (
    <header className="bg-white shadow-sm sticky top-0 z-50">
      <div className="container mx-auto px-4 py-3 flex flex-wrap items-center justify-between">
        {/* Logo */}
        <Link to="/" className="flex items-center space-x-3">
          <img src={logo} alt="EDBOT" className="w-12 h-12" />
          <span className="text-2xl font-extrabold">
            ED<span className="text-blue-600">BOT</span>
          </span>
        </Link>

        {/* Desktop links */}
        <nav className="hidden md:flex items-center space-x-6 font-medium text-sm">
          <a href="#features"    className="hover:text-blue-600">Características</a>
          <a href="#testimonios" className="hover:text-blue-600">Testimonios</a>
          <a href="#contacto"    className="hover:text-blue-600">Contacto</a>

          {/* Botones: dependen de si el usuario trae token */}
          {isAuth ? (
            <Link
              to="/app/diagnostico"
              className="px-4 py-2 rounded-full bg-blue-600 text-white
                         hover:bg-blue-700 transition"
            >
              Ir al panel
            </Link>
          ) : (
            <>
              <Link
                to="/login"
                className="px-4 py-2 rounded-full border border-blue-600
                           text-blue-600 hover:bg-blue-600 hover:text-white transition"
              >
                Iniciar sesión
              </Link>
              <Link
                to="/login?action=register"
                className="px-4 py-2 rounded-full bg-blue-600 text-white
                           hover:bg-blue-700 transition"
              >
                Regístrate gratis
              </Link>
            </>
          )}
        </nav>

        {/* Mobile burger */}
        <button
          onClick={() => setOpen(!open)}
          className="md:hidden text-gray-600 focus:outline-none"
        >
          <i className="fas fa-bars text-xl" />
        </button>
      </div>

      {/* Mobile menu */}
      {open && (
        <div className="md:hidden bg-white border-t shadow-sm">
          <a onClick={() => setOpen(false)} href="#features"    className="block px-4 py-3">Características</a>
          <a onClick={() => setOpen(false)} href="#testimonios" className="block px-4 py-3">Testimonios</a>
          <a onClick={() => setOpen(false)} href="#contacto"    className="block px-4 py-3">Contacto</a>

          {/* Opcional: destaca también en móvil */}
          {/* enlaces dependen del token */}
          {isAuth ? (
            <Link
              onClick={() => setOpen(false)}
              to="/app/diagnostico"
              className="block px-4 py-3 text-blue-600 font-medium"
            >
              Ir al panel
            </Link>
          ) : (
            <>
              <Link onClick={() => setOpen(false)}
                    to="/login"
                    className="block px-4 py-3 text-blue-600 font-medium">
                Iniciar sesión
              </Link>
              <Link onClick={() => setOpen(false)}
                    to="/login?action=register"
                    className="block px-4 py-3 font-medium">
                Regístrate gratis
              </Link>
            </>
          )}
        </div>
      )}
    </header>
  );
};

export default Navbar;
